export default __webpack_public_path__ + "00b21ffa7f668273cca2e3b4c0b181db.webp";